import { Container, MarkdownRemote, SectionTitle } from '@sloyd/ui';
import { ROOT } from 'shared-base';
import { Wrapper } from './PageChangeLog.style';

export type PageChangeLogProps = {};

export function PageChangeLog(_props: PageChangeLogProps) {
  return (
    <Wrapper className='PageChangeLog-wrapper' data-testid='PageChangeLog-wrapper'>
      <Container size='md'>
        <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Change log' />
        <MarkdownRemote mode='dark' url={`${ROOT}/changelog.md?${Math.random()}`} />
      </Container>
    </Wrapper>
  );
}

export default PageChangeLog;
